export default __webpack_public_path__ + "static/media/PngItem_1503945.2a907e6b.png";